// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"69":"7df6fcc3a14a3672b11d","655":"8b2a3abb4dd5953047e0"}[chunkId] + ".js";
};